import { render, staticRenderFns } from "./MailUndoPage.vue?vue&type=template&id=09f258b2&scoped=true&"
import script from "./MailUndoPage.vue?vue&type=script&lang=ts&"
export * from "./MailUndoPage.vue?vue&type=script&lang=ts&"
import style0 from "./MailUndoPage.vue?vue&type=style&index=0&id=09f258b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f258b2",
  null
  
)

export default component.exports